var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advert-li",on:{"click":_vm.goDetail}},[_c('img',{staticClass:"adv-img",attrs:{"src":_vm.imgUrl}}),_c('div',{staticClass:"badge-m"},[_vm._v("广告")])])
}
var staticRenderFns = []

export { render, staticRenderFns }